// Ensure theme object exists and quickbuyStyle is not 'off'
if (window.theme && theme.settings && theme.settings.quickbuyStyle != 'off') {
  theme.quickbuy = {
    currentRequestAbortController: null,
    modalElement: null, // Will hold the modal HTML element
    modalContentElement: null, // Will hold the modal's inner content area
    openTriggerElement: null, // To keep track of the element that opened the modal

    init: () => {
      // Create the modal structure if it doesn't exist
      if (!theme.quickbuy.modalElement) {
        theme.quickbuy.createModalStructure();
      }

      theme.addDelegateEventListener(document, 'click', '.quickbuy-toggle', (evt, delEl) => {
        evt.preventDefault(); // Always prevent default for modal behavior

        theme.quickbuy.openTriggerElement = delEl; // Store the element that initiated the open

        const productUrl = delEl.href;

        // Cancel current request if one exists
        if (theme.quickbuy.currentRequestAbortController) {
          theme.quickbuy.currentRequestAbortController.abort('Existing request not needed');
        }
        theme.quickbuy.currentRequestAbortController = new AbortController();

        // Show loading spinner in the modal
        theme.quickbuy.modalContentElement.innerHTML = '<div class="loading-spinner"></div>';
        theme.quickbuy.openModal(); // Open the modal immediately with the spinner

        // Load content into the modal
        fetch(productUrl, {
          method: 'get',
          signal: theme.quickbuy.currentRequestAbortController.signal
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = response;
          const newDetail = tmpl.content.querySelector('.quickbuy-content').cloneNode(true);

          // Convert to quickbuy content (keep existing transformations)
          newDetail.querySelectorAll('.more').forEach((el) => { el.href = productUrl; });
          newDetail.querySelectorAll('.product-title').forEach((el) => {
            el.innerHTML = `<a href="${productUrl}">${el.innerHTML}</a>`; // Fix: Use productUrl directly
          });
          newDetail.querySelectorAll('.show-gallery').forEach((el) => {
            el.classList.remove('show-gallery');
            el.href = productUrl;
          });
          newDetail.querySelectorAll('.not-in-quickbuy').forEach((el) => { el.remove(); });
          newDetail.querySelectorAll('.only-in-quickbuy').forEach((el) => { el.classList.remove('only-in-quickbuy'); });
          newDetail.querySelectorAll('.sticky-content-container').forEach((el) => { el.classList.remove('sticky-content-container'); });
          newDetail.querySelectorAll('pickup-availability').forEach((el) => { el.remove(); });
          newDetail.querySelectorAll('variant-picker[data-update-url="true"]').forEach((el) => { el.dataset.updateUrl = false; });
          newDetail.querySelectorAll('noscript').forEach((el) => el.remove());

          // Enforce thumbnails-under gallery layout for modal (if desired)
          // You might want to adjust these classes based on how your quickbuy-content is structured
          // For a modal, specific layout adjustments might be less critical or handled by modal CSS
          newDetail.querySelectorAll('.media-gallery .main-image carousel-slider').forEach((el) => { el.classList.remove('mobile-only'); });
          newDetail.querySelectorAll('.product-media-collage').forEach((el) => { el.remove(); });
          newDetail.querySelectorAll('.media-gallery .thumbnails').forEach((el) => { el.classList.remove('mobile-only'); });
          ['media-gallery--layout-carousel-beside', 'media-gallery--layout-columns-1', 'media-gallery--layout-columns-2', 'media-gallery--layout-collage-1', 'media-gallery--layout-collage-2'].forEach((cl) => {
            newDetail.querySelectorAll(`.${cl}`).forEach((el) => {
              el.classList.remove(cl);
              el.classList.add('media-gallery--layout-carousel-under'); // Or any other suitable modal layout class
            });
          });

          // Add any external resources (important for styles/scripts needed by product details)
          tmpl.content.querySelectorAll('.section-main-product link[rel="stylesheet"]').forEach((el) => {
            if (!document.querySelector(`link[rel="stylesheet"][href="${el.getAttribute('href')}"]`)) {
              document.head.insertAdjacentHTML('beforeend', el.outerHTML);
            }
          });
          tmpl.content.querySelectorAll('.section-main-product script[src]').forEach((el) => {
            if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
              const scr = document.createElement('script');
              scr.src = el.getAttribute('src');
              scr.defer = 'defer';
              document.head.appendChild(scr);
            }
          });

          // Insert fetched content into the modal
          theme.quickbuy.modalContentElement.innerHTML = ''; // Clear spinner
          theme.quickbuy.modalContentElement.appendChild(newDetail);

          // Dispatch event after content is loaded and inserted
          theme.quickbuy.modalElement.dispatchEvent(new CustomEvent('on:quickbuy:after-open', { bubbles: true }));

          // Focus on the first focusable element inside the modal for accessibility
          const focusableElements = theme.quickbuy.modalContentElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const firstFocusable = focusableElements[0];
          if (firstFocusable) {
            firstFocusable.focus();
          }

        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Quickbuy fetch aborted:', error.message);
          } else {
            console.error('Quickbuy fetch error:', error);
            // Optionally, display an error message in the modal
            theme.quickbuy.modalContentElement.innerHTML = '<p>Error loading product details. Please try again.</p>';
          }
        });
      });

      // Close modal on escape key
      document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape' && theme.quickbuy.modalElement.classList.contains('is-open')) {
          theme.quickbuy.closeModal();
        }
      });
    },

    // --- Modal Management Functions ---

    // Creates the basic modal HTML structure and appends it to the body
    createModalStructure: () => {
      const modalHTML = `
        <div class="quickbuy-modal-overlay" id="QuickbuyModal" role="dialog" aria-modal="true" tabindex="-1">
          <div class="quickbuy-modal-wrapper">
            <button class="quickbuy-modal-close" aria-label="Close Quick Buy">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 16 16">
          <path d="M15.42 1.58A.996.996 0 0 0 14 0L8 6 2 0A.996.996 0 0 0 .58 1.58L6.17 7.17 0.58 12.75a.996.996 0 0 0 1.42 1.42L8 8.83l6 6a.996.996 0 0 0 1.42-1.42L9.83 7.17z"/>
        </svg>
            </button>
            <div class="quickbuy-modal-content">
              </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
      theme.quickbuy.modalElement = document.getElementById('QuickbuyModal');
      theme.quickbuy.modalContentElement = theme.quickbuy.modalElement.querySelector('.quickbuy-modal-content');

      // Add event listener for close button
      theme.quickbuy.modalElement.querySelector('.quickbuy-modal-close').addEventListener('click', theme.quickbuy.closeModal);

      // Close when clicking outside the modal content
      theme.quickbuy.modalElement.addEventListener('click', (evt) => {
        if (evt.target === theme.quickbuy.modalElement) {
          theme.quickbuy.closeModal();
        }
      });
    },

    openModal: () => {
      document.body.classList.add('quickbuy-modal-open'); // Add class to body to prevent scrolling
      theme.quickbuy.modalElement.classList.add('is-open');
      theme.quickbuy.modalElement.setAttribute('aria-hidden', 'false');
      // Ensure modal is visible before attempting to focus
      setTimeout(() => {
        theme.quickbuy.modalElement.focus(); // Focus the modal for accessibility
      }, 0); // Allow browser to render visibility change
    },

    closeModal: () => {
      document.body.classList.remove('quickbuy-modal-open');
      theme.quickbuy.modalElement.classList.remove('is-open');
      theme.quickbuy.modalElement.setAttribute('aria-hidden', 'true');
      theme.quickbuy.modalContentElement.innerHTML = ''; // Clear content when closing

      // Return focus to the element that opened the modal
      if (theme.quickbuy.openTriggerElement) {
        theme.quickbuy.openTriggerElement.focus();
        theme.quickbuy.openTriggerElement = null; // Clear reference
      }

      theme.quickbuy.modalElement.dispatchEvent(new CustomEvent('on:quickbuy:after-close', { bubbles: true }));
    }
  };

  theme.quickbuy.init();
}